import posthog from "posthog-js";

let initialized = false;

/**
 * Initialise PostHog from environment variables.
 * Safe to call multiple times — guarded by `initialized`.
 * Silently no-ops when REACT_APP_POSTHOG_KEY is not set, so local/test
 * environments don't need a real key.
 */
export function initPostHog() {
  if (initialized) return;

  const key = process.env.REACT_APP_POSTHOG_KEY;
  const host = process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com";

  if (!key) return;

  posthog.init(key, {
    api_host: host,
    person_profiles: "identified_only",
    capture_pageview: true,
    capture_pageleave: true,
    session_recording: {
      recordCrossOriginIframes: true,
      capturePerformance: false,
    },
    loaded: (ph) => {
      // Lightweight sanity log — visible in browser DevTools after deploy.
      // PostHog → Live events should also show a $pageview within ~30s.
      // eslint-disable-next-line no-console
      console.info(
        `[posthog] initialised → ${host} (distinct_id=${ph.get_distinct_id()})`
      );
    },
  });

  initialized = true;
}

export { posthog };
